import { NavigationGuard, NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/store/AuthStore";
import { useMainStore } from "@/store/MainStore";
import useFeatureFlagsStore from "@/store/feature-flags";

export const AuthGuard: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();
  await featureFlagGuard(to, next);
  if (!authStore?.loggedInUser?.id) {
    await authStore.fetchCurrentUser();
  }
  return next();
};

const featureFlagGuard = async (to: RouteLocationNormalized, next: NavigationGuardNext) => {
  const featureFlag = to.meta?.featureFlag as string;
  if (featureFlag) {
    const mainStore = useMainStore();
    const featureFlagStore = useFeatureFlagsStore();
    await featureFlagStore.setTreatments({code: mainStore.selectedStore?.code, domain: mainStore.selectedStore?.domain});
    if (!featureFlagStore.isOn(featureFlag)) {
      next({ name: "Home" });
    }
  }
};
